import { render, staticRenderFns } from "./document_extraction_page.vue?vue&type=template&id=469a254c"
import script from "./document_extraction_page.vue?vue&type=script&lang=js"
export * from "./document_extraction_page.vue?vue&type=script&lang=js"
import style0 from "./document_extraction_page.vue?vue&type=style&index=0&id=469a254c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports